var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "sidebar-head" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("supervisors")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("title.sidebar")))]),
      ]),
      _vm._v(" "),
      _vm.initialized
        ? [
            _c("div", { staticClass: "search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search,
                    expression: "search",
                  },
                ],
                attrs: {
                  id: "staffSearch",
                  placeholder: "Zoek naam of kwalificatie",
                },
                domProps: { value: _vm.search },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.search = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tabs" }, [
              _c(
                "button",
                {
                  staticClass: "tab",
                  class: _vm.ctype == 1 ? "active" : "",
                  attrs: { "data-staff-tab": "available" },
                  on: {
                    click: function ($event) {
                      return _vm.showAttendant(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("available")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tab",
                  class: _vm.ctype == 0 ? "active" : "",
                  attrs: { "data-staff-tab": "contract" },
                  on: {
                    click: function ($event) {
                      return _vm.showAttendant(0)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("contract")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tab",
                  class: _vm.ctype == -1 ? "active" : "",
                  attrs: { "data-staff-tab": "all" },
                  on: {
                    click: function ($event) {
                      return _vm.showAttendant(-1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("all")))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "staff-list", attrs: { id: "staffList" } },
              [
                _c(
                  "draggable",
                  {
                    attrs: {
                      "model-value": _vm.list,
                      "item-key": "id",
                      group: { name: "users", pull: "clone", put: false },
                      sort: false,
                      clone: _vm.cloneUser,
                    },
                  },
                  _vm._l(_vm.list, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "staff",
                        attrs: { "data-id": item.id, "data-name": item.name },
                      },
                      [
                        _c("div", { staticClass: "staff-top" }, [
                          _c("div", [
                            _c("strong", [_vm._v(_vm._s(item.name))]),
                            _c(
                              "small",
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      item.contractType == 0
                                        ? "Contractdag"
                                        : "Aangemeld"
                                    ) +
                                    "\n                                "
                                ),
                                _vm._l(item.freeSlots, function (slot) {
                                  return [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.getSlot(slot)) +
                                        "\n                                "
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "staff-status text-lowercase",
                              class:
                                item.contractType == 0
                                  ? "contract"
                                  : "available",
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    item.contractType == 0
                                      ? _vm.$t("contract")
                                      : _vm.$t("available")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "qualification-row" },
                          _vm._l(item.educationQualifications, function (edu) {
                            return _c("span", { staticClass: "tag" }, [
                              _vm._v(_vm._s(edu)),
                            ])
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]
        : _c("div", [_c("spinner")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "side-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn primary",
            attrs: { id: "qualificationButton" },
            on: { click: _vm.setQualification },
          },
          [_vm._v(_vm._s(_vm.$t("managequalification")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn", attrs: { id: "availabilityButton" } },
          [_vm._v(_vm._s(_vm.$t("checkavailibility")))]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }